import { Avatar, IconButton, Tooltip } from '@mui/material';
import { PRIMARY } from '../../constants/Colors';
import _ from 'lodash';

export interface BakeasyButtonIconProps {
  color?: any;
  label?: string;
  disabled?: boolean;
  icon?: any;
  tooltipTitle?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function stringAvatar(name: any) {
  return { sx: { bgcolor: PRIMARY }, children: `${_.capitalize(name?.slice(0, 1))}` };
}

export function BakeasyButtonIcon(props: BakeasyButtonIconProps) {
  return (
    <Tooltip title={props.tooltipTitle}>
      {props?.icon ? (
        <IconButton color={props.color} size="small" onClick={props.onClick}>
          {props?.icon}
        </IconButton>
      ) : (
        <IconButton color={props.color} onClick={props.onClick}>
          <Avatar {...stringAvatar(props?.label?.toString())}></Avatar>
        </IconButton>
      )}
    </Tooltip>
  );
}
